const state = {
  filter: [],
  pageSize: 25,
  currentPage: 1,
  pageStart: 1,
  pageEnd: 10,
  maxPage: 1,
  orderBy: 'asc',
  context: ''
}

const mutations = {
  datatable_currentPage: function (state, payload) {
    state.currentPage = payload
  },
  datatable_pageSize: function (state, payload) {
    state.pageSize = payload
  },
  datatable_maxPage: function (state, payload) {
    state.maxPage = payload
  },
  datatable_orderby: function (state, payload) {
    state.orderBy = payload
  },
  datatable_push_filter: function (state, payload) {
    state.filter.push(payload)
  },
  datatable_clear_filter: function (state) {
    state.filter = []
  },
  datatable_context: function (state, payload) {
    state.context = payload
  },
  datatable_pageStart: function (state, payload) {
    state.pageStart = payload
  },
  datatable_pageEnd: function (state, payload) {
    state.pageEnd = payload
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/datatable.js